import type { HttpClient } from '../http';
import { unwrap, type ApiEnvelope } from '../envelope';
import type { AuthResponse, ClientRegisterPayload, PublicInvite } from '../types';
import type { CreateInviteRequest, InviteResponse } from '../types/domain';

export function inviteEndpoints(http: HttpClient) {
  return {
    publicLookup: (code: string) =>
      http.get<ApiEnvelope<PublicInvite>>(`/v1/public/invites/${encodeURIComponent(code)}`).then(unwrap),
    clientRegister: (payload: ClientRegisterPayload) =>
      http.post<ApiEnvelope<AuthResponse>>('/v1/auth/client-register', payload).then(unwrap),
    acceptInvite: (code: string) =>
      http.post<ApiEnvelope<unknown>>('/v1/invites/accept', { code }).then(unwrap),
    // Lado negocio: generar/listar/revocar invitaciones.
    create: (body: CreateInviteRequest) =>
      http.post<ApiEnvelope<InviteResponse>>('/v1/invites', body).then(unwrap),
    listMine: () => http.get<ApiEnvelope<InviteResponse[]>>('/v1/invites').then(unwrap),
    revoke: (id: string) => http.del<ApiEnvelope<void>>(`/v1/invites/${id}`).then(unwrap),
  };
}

export type InviteEndpoints = ReturnType<typeof inviteEndpoints>;
